import { render, staticRenderFns } from "./StudioSettingsAdmins.vue?vue&type=template&id=070814f4&scoped=true"
import script from "./StudioSettingsAdmins.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioSettingsAdmins.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioSettingsAdmins.vue?vue&type=style&index=0&id=070814f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070814f4",
  null
  
)

export default component.exports